import { put, call, takeEvery } from 'typed-redux-saga';
import { toast } from 'react-toastify';

import GoldGateway from '~apis/gold';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages } from '~utils/constants';
import { MetalTypeEnum } from '~utils/enums';

export default function* watchGetAllInventories(api: GoldGateway): SagaWatcherReturnType {
    yield takeEvery('gold/goldGetAllInventoriesAttempt', handleGetAllInventories, api);
}

function* handleGetAllInventories(api: GoldGateway) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;
    const {
        branchName,
        branchCode,
        metalType,
        goldType,
        silverType,
        ...rest
    } = reduxState.gold.params.inventoryFilterParams;

    const params = {
        ...rest,
        metalType,
        ...(metalType === MetalTypeEnum.Gold
            ? { goldType }
            : { silverType }),
        ...(branchCode ? { branchCode } : {}),
    };

    const response = yield* call([api, api.getAllInventories], {
        authToken,
        ...params,
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.goldGetAllInventoriesFailure(response.message || ErrorMessages.GenericError));
        toast.error(response.message || ErrorMessages.GenericError);
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(combinedActions.goldGetAllInventoriesSuccess(response.data));
    }
}
